import { Spacings, View } from "react-native-ui-lib";
import { Button } from "@towersystems/roam-common-native";
import Sale from "../../../../utilities/data/model/Sale";
import { of } from "@nozbe/watermelondb/utils/rx";
import {
  withObservables,
  ExtractedObservables,
} from "@nozbe/watermelondb/react";
import { useTranslation } from "react-i18next";

const getObservables = ({ sale }: { sale: Sale }) => ({
  items: sale ? sale.items.observe() : of([]),
});

export interface MobileCartButtonRendererProps
  extends ExtractedObservables<ReturnType<typeof getObservables>> {
  sale?: Sale;
  navigation: any;
}

const MobileCartButtonRenderer = ({
  sale,
  navigation,
  items,
}: MobileCartButtonRendererProps) => {
  const { t } = useTranslation("pos");

  const numberLineItems = items?.reduce((acc, item) => {
    return acc + item.quantity;
  }, 0);

  if (!sale) {
    return (
      <View flex>
        <Button
          style={{ marginLeft: Spacings.s4 }}
          onPress={() =>
            navigation.navigate("ActionsRootScreen", {
              screen: "MoreActionsScreen",
            })
          }
          isAction
          label={t("button.actions")}
          fullWidth
        />
      </View>
    );
  }

  return (
    <Button
      isAction
      style={{ marginLeft: Spacings.s4 }}
      disabled={false}
      onPress={() => navigation.navigate("MobileCartScreen")}
      label={`Cart (${numberLineItems})`}
    ></Button>
  );
};

const enhance = withObservables(["sale"], getObservables);

export const MobileCartButton = enhance(MobileCartButtonRenderer);
